import React from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider, useSnackbar, MaterialDesignContent } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Button } from '@mui/material';
import { styled, ThemeProvider } from '@mui/material/styles';
import { mainTheme } from '../assets/theme';
import { Colors } from '../assets/theme/Colors';

const mountPoint = document.createElement('div');

document.body.appendChild(mountPoint);
const root = ReactDOM.createRoot(mountPoint);

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: Colors.green.light,
  },
}));

function NotistackProvider({ variant, duration, msg, toastButton, persist, showCloseButton = true }) {
  const ShowSnackbar = ({ message, variant }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    enqueueSnackbar(message, {
      variant,
      persist: persist,
      preventDuplicate: true,
      action: key => {
        return (
          <>
            {toastButton && (
              <Button
                {...toastButton}
                onClick={() => {
                  if (toastButton.onClick) {
                    toastButton.onClick();
                  }
                  closeSnackbar(key);
                }}
              >
                {toastButton.label}
              </Button>
            )}

            {showCloseButton && (
              <IconButton onClick={() => closeSnackbar(key)} size="large">
                <CloseIcon sx={{ color: '#ffffff' }} />
              </IconButton>
            )}
          </>
        );
      },
    });

    return null;
  };

  const isMobileBottomMenuVisible = document.getElementById('rescuer-mobile-app-bar');

  return (
    <SnackbarProvider
      maxSnack={3}
      classes={{
        anchorOriginBottomLeft: {
          bottom: isMobileBottomMenuVisible ? '83px !important' : undefined,
        },
      }}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      autoHideDuration={duration}
      Components={{
        success: StyledMaterialDesignContent,
      }}
    >
      <ShowSnackbar message={msg} variant={variant} />
    </SnackbarProvider>
  );
}

export default {
  success(msg, persist = false, toastButton = undefined) {
    this.toast(msg, 'success', 3000, persist, toastButton);
  },

  warning(msg) {
    this.toast(msg, 'warning');
  },

  info(msg, duration = 5000, showCloseButton = true) {
    this.toast(msg, 'info', duration, false, undefined, showCloseButton);
  },

  error(msg, duration = 5000) {
    this.toast(msg, 'error', duration);
  },

  toast(msg, variant = 'default', duration = 3000, persist = false, toastButton = undefined, showCloseButton = true) {
    root.render(
      <ThemeProvider theme={mainTheme}>
        <NotistackProvider
          toastButton={toastButton}
          showCloseButton={showCloseButton}
          persist={persist}
          msg={msg}
          variant={variant}
          duration={duration}
        />
      </ThemeProvider>
    );
  },
};
